export default "__VITE_ASSET__BeBj874J__"